import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as dashboardActions from '../actions/dashboard';
import { fetchingState } from '@constants';

const initialState = {
  totalCases: { data: {}, state: null },
  propUse: { data: [], state: null },
  statistics: { data: [], state: null },
  upcoming: { data: [], state: null },
  statusBreakdown: { data: [], state: null },
  detail: { data: [], state: null },
  timeline: { data: [], state: null },
  date: null,
  appraiser: 'All',
  selectedDashboardYear: 'All',
  upcomingFilter: 'nonFinalized',
  caseStatusFilter: 'nonFinalized',
  searchModifier: null,
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case dashboardActions.SET_SEARCH_MODIFIER:
      return state.setIn(['searchModifier'], action.data);
    case dashboardActions.SET_UPCOMING_FILTER:
      return state.setIn(['upcomingFilter'], action.payload);
    case dashboardActions.SET_CASE_STATUS_FILTER:
      return state.setIn(['caseStatusFilter'], action.payload);
    case dashboardActions.SET_SELECTED_DASHBOARD_YEAR:
      return state.setIn(['selectedDashboardYear'], action.payload);

    case dashboardActions.SET_DASHBOARD_APPRAISER:
      return state.setIn(['appraiser'], action.data);
    case dashboardActions.SET_DASHBOARD_DATE:
      return state.setIn(['date'], action.data);

    case dashboardActions.DASHBOARD_GET_TOTAL_CASES[START]: {
      return state.setIn(['totalCases', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_TOTAL_CASES[SUCCESS]: {
      return state
        .setIn(['totalCases', 'state'], fetchingState.LOADED)
        .setIn(
          ['totalCases', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case dashboardActions.DASHBOARD_GET_TOTAL_CASES[ERROR]: {
      return state.setIn(['totalCases', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_PROP_USE_DATA[START]: {
      return state.setIn(['propUse', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_PROP_USE_DATA[SUCCESS]: {
      return state
        .setIn(['propUse', 'state'], fetchingState.LOADED)
        .setIn(
          ['propUse', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_PROP_USE_DATA[ERROR]: {
      return state.setIn(['propUse', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_UPCOMING[START]: {
      return state.setIn(['upcoming', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_UPCOMING[SUCCESS]: {
      return state
        .setIn(['upcoming', 'state'], fetchingState.LOADED)
        .setIn(
          ['upcoming', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_UPCOMING[ERROR]: {
      return state.setIn(['upcoming', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_STATUS_BREAKDOWN[START]: {
      return state.setIn(['statusBreakdown', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_STATUS_BREAKDOWN[SUCCESS]: {
      return state
        .setIn(['statusBreakdown', 'state'], fetchingState.LOADED)
        .setIn(
          ['statusBreakdown', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_STATUS_BREAKDOWN[ERROR]: {
      return state.setIn(['statusBreakdown', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_DETAIL[START]: {
      return state.setIn(['detail', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_DETAIL[SUCCESS]: {
      return state
        .setIn(['detail', 'state'], fetchingState.LOADED)
        .setIn(['detail', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case dashboardActions.DASHBOARD_GET_DETAIL[ERROR]: {
      return state.setIn(['detail', 'state'], fetchingState.ERROR);
    }

    case dashboardActions.DASHBOARD_GET_TIMELINE[START]: {
      return state.setIn(['timeline', 'state'], fetchingState.FETCHING);
    }
    case dashboardActions.DASHBOARD_GET_TIMELINE[SUCCESS]: {
      return state
        .setIn(['timeline', 'state'], fetchingState.LOADED)
        .setIn(
          ['timeline', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case dashboardActions.DASHBOARD_GET_TIMELINE[ERROR]: {
      return state.setIn(['timeline', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
